import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { ptBrLocale } from 'ngx-bootstrap/locale';
import {
  BsDatepickerModule,
  BsDaterangepickerConfig,
  BsLocaleService,
} from 'ngx-bootstrap/datepicker';
import { environment } from 'src/environments/environment';

defineLocale('pt-br', ptBrLocale);


@Component({
  selector: 'app-filtro-periodo',
  standalone: true,
  imports: [CommonModule, FormsModule, BsDatepickerModule],
  templateUrl: './filtro-periodo.component.html',
  styleUrls: ['./filtro-periodo.component.scss'],
})


export class FiltroPeriodoComponent implements OnInit, OnChanges {
  BASE_IMG_URL: string = environment.BASE_IMG_URL;

  @Input() config: Partial<BsDaterangepickerConfig> = {
    containerClass: 'bs-datepicker',
    rangeInputFormat: 'DD/MM/YYYY',
    showWeekNumbers: false,
    selectFromOtherMonth: true,
    isAnimated: true,
    displayMonths: 1,
  };

  @Output() intervaloSelecionadoChange = new EventEmitter<{
    periodBegin: string;
    periodEnd: string;
  } | null>();
  @Output() periodoLimpo = new EventEmitter<void>();

  dataInicio = '';
  dataFim = '';
  mostrarPeriodo = false;

  private _intervaloSelecionado: Date[] | null = null;

  constructor(private localeService: BsLocaleService) {
    this.localeService.use('pt-br'); 
  }

  ngOnInit(): void {
    this.updateInputs();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['intervaloSelecionado']) this.updateInputs();
  }

  togglePeriodo() {
    this.mostrarPeriodo = !this.mostrarPeriodo;
  }

  onPeriodoChange() {
    this.mostrarPeriodo = false;

    if (this._intervaloSelecionado?.length === 2) {
      this.updateInputs();
      this.intervaloSelecionadoChange.emit({
        periodBegin: this.dataInicio,
        periodEnd: this.dataFim,
      });
    } else {
      this.clearPeriodo();
    }
  }

  limparPeriodo() {
    this.clearPeriodo();
  }

  private clearPeriodo() {
    this._intervaloSelecionado = null;
    this.dataInicio = '';
    this.dataFim = '';
    this.mostrarPeriodo = false;

    this.intervaloSelecionadoChange.emit(null);
    this.periodoLimpo.emit();
  }

  private updateInputs() {
    if (this._intervaloSelecionado?.length === 2) {
      this.dataInicio = this.formatDate(this._intervaloSelecionado[0]);
      this.dataFim = this.formatDate(this._intervaloSelecionado[1]);
    } else {
      this.dataInicio = '';
      this.dataFim = '';
    }
  }

  formatDate(date: Date): string {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
    
  }

  toLocalDate(value: Date | string | null | undefined): Date | null {
    if (!value) return null;
    if (value instanceof Date && !isNaN(value.getTime())) {
      return new Date(value.getFullYear(), value.getMonth(), value.getDate());
    }
    if (typeof value === 'string') {
      const [y, m, d] = value.split('-').map(Number);
      if (y && m && d) return new Date(y, m - 1, d);
    }
    return null;
  }

  get intervaloSelecionado(): Date[] | null {
    return this._intervaloSelecionado;
  }

  @Input() set intervaloSelecionado(value: Date[] | null) {
    if (Array.isArray(value) && value.length === 2) {
      const a = this.toLocalDate(value[0]);
      const b = this.toLocalDate(value[1]);
      this._intervaloSelecionado = a && b ? [a, b] : null;
    } else {
      this._intervaloSelecionado = null;
    }
    this.updateInputs();
  }
}
